var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrd001DeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M16.525 7.46826C16.525 7.46826 15.982 14.2033 15.667 17.0403C15.517 18.3953 14.68 19.1893 13.309 19.2143C10.7 19.2613 8.08798 19.2643 5.47998 19.2093C4.16098 19.1823 3.33798 18.3783 3.19098 17.0473C2.87398 14.1853 2.33398 7.46826 2.33398 7.46826",
    stroke: "#FF0909",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M17.9082 4.23975H0.950195",
    stroke: "#FF0909",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    d: "M14.6408 4.23973C13.8558 4.23973 13.1798 3.68473 13.0258 2.91573L12.7828 1.69973C12.6328 1.13873 12.1248 0.750732 11.5458 0.750732H7.31277C6.73377 0.750732 6.22577 1.13873 6.07577 1.69973L5.83277 2.91573C5.67877 3.68473 5.00277 4.23973 4.21777 4.23973",
    stroke: "#FF0909",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrd001DeleteIcon);
export default __webpack_public_path__ + "static/media/ord_001_delete_icon.a9bc50fc70e73758731c19f202b89cc2.svg";
export { ForwardRef as ReactComponent };